import type {
    AddToCartBaseItem,
    AddToCartCrawlEvent,
    AddToCartEcommerce,
    AddToCartPrecrawlEvent,
    StockAvailability,
    YesNo,
} from '@/shared/analytics';

type DeliveryAvailability = {
    sth_availability: YesNo;
    sth_stock_availability: Nullable<StockAvailability>;
    bopis_availability: YesNo;
    bopis_stock_availability: Nullable<StockAvailability>;
    sdd_availability: YesNo;
    sdd_stock_availability: Nullable<StockAvailability>;
};

type AddToCartBaseEvent = {
    event: 'add_to_cart';
    ecommerce: Omit<AddToCartEcommerce<AddToCartBaseItem>, 'items'> & {
        items: AddToCartBaseItem[];
    };
};

type PrecrawlEnrichmentData = {
    autoshipFlag: 'precrawl';
    stockAvailability: Nullable<StockAvailability>;
};

type CrawlEnrichmentData = {
    autoshipFlag: 'crawl';
    deliveryAvailability: DeliveryAvailability;
};

type AutoshipEnrichmentData = PrecrawlEnrichmentData | CrawlEnrichmentData;

export function enrichAddToCartEvent(
    event: AddToCartBaseEvent,
    enrichmentData: AutoshipEnrichmentData
): AddToCartPrecrawlEvent | AddToCartCrawlEvent {
    if (enrichmentData.autoshipFlag === 'precrawl') {
        const items = event.ecommerce.items.map(item => ({
            ...item,
            autoship_stock_availability: enrichmentData.stockAvailability,
        }));

        return {
            event: 'add_to_cart',
            ecommerce: {
                ...event.ecommerce,
                items,
            },
        } satisfies AddToCartPrecrawlEvent;
    }

    const items = event.ecommerce.items.map(item => ({
        ...item,
        ...enrichmentData.deliveryAvailability,
    }));

    return {
        event: 'add_to_cart',
        ecommerce: {
            ...event.ecommerce,
            items,
        },
    } satisfies AddToCartCrawlEvent;
}

export type { AddToCartBaseEvent, AutoshipEnrichmentData, DeliveryAvailability };
